import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
    appSetTab,
    appSetRoute,
    logoutRequest
} from '../../store/actions';

import {
    dialogOpen,
    dialogClose
} from '../../store/actions/msgDialog.js';


import Footer from '../../components/Footer'

class Cfooter extends Component {
    constructor(props) {
        super(props);

        this.logout = this.logout.bind(this);
        this.setRoute = this.setRoute.bind(this);
        this.tabSelected = this.tabSelected.bind(this);
    }

    tabSelected(tab) {
        switch (tab) {
            case 'deliv':
                this.props.appSetTab('deliv');
                this.props.appSetRoute('deliv');
                break;

            case 'sensors':
                this.props.appSetTab('sensors');
                this.props.appSetRoute('sensors');
                break;

            case 'profile':
                this.props.appSetTab('profile');
                this.props.appSetRoute('profile');
                break;

            default:
                break;
        }
    }

    logout() {
        this.props.logoutRequest();
    }

    setRoute(data) {
        this.props.appSetRoute(data);
    }

    render() {
        return (
            <Footer
                activeTab={this.props.activeTab}
                loginState={this.props.loginState}
                logoutRequest={this.logout}
                tabSelected={this.tabSelected}
                texts={{
                    deliv: this.props.txt_deliv,
                    exit: this.props.txt_exit,
                    sensors: this.props.txt_sensors,
                    profile: this.props.txt_profile
                }}>
            </Footer>
        );
    }
}

const mapStateToProps = state => {
    const getText = (id) => {
        let text = '';
        try {
            text = state.app.texts[id][state.app.language];            
        } catch (err) {
            text = '';
        }
        return text;
    }

    return {
        activeTab: state.app.activeTab,
        loginState: state.login.loginState,

        txt_confirm: getText("0030"),
        txt_yes: getText("0031"),
        txt_no: getText("0032"),
        txt_logout: getText("0033"),

        txt_deliv: getText("0006"),
        txt_exit: getText("0022"),
        txt_sensors: getText("0007"),
        txt_profile: getText("0008")
    }
}

const mapDispatchToProps = dispatch => {
    return {
        appSetRoute: (route) => dispatch(appSetRoute(route)),
        appSetTab: (tab) => dispatch(appSetTab(tab)),
        dialogOpen: (data) => dispatch(dialogOpen(data)),
        dialogClose: () => dispatch(dialogClose()),
        logoutRequest: () => dispatch(logoutRequest())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Cfooter);



// WEBPACK FOOTER //
// ./src/containers/Cfooter/index.js